<!--
오류 라벨 컴포넌트
-->
<script>
    export default {
        props: {
            /**
             * 상품ID
             */
            prodId: {
                type: Number,
            },
            /**
             * 오류ID
             */
            errorId: {
                type: Number,
            },
            /**
             * 상세보기 팝업기능을 사용안함
             * - true : 사용안함
             * - false : (디폴트) 사용
             */
            disabledView: {
                type: Boolean,
                default: false,
            },
            /**
             * 현재 설정중인 오류인지 기록인지 구분
             * - true : 오류기록
             * - false : 현재 설정중
             */
            history: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                /**
                 * 데이터 로드 상태
                 *  - unload
                 *  - loading
                 *  - laoded
                 */
                loadState: 'unload',

                /**
                 * (bool)
                 * 팝업 display 상태
                 */
                viewDisplay: false,

                /**
                 * (object)
                 * 오류정보
                 *
                 */
                error: {},
            };
        },
        computed: {
            /**
             * 라벨명
             */
            labelText() {
                if (this.history) {
                    return "오류기록";
                } else {
                    return "오류";
                }
            },
        },
        methods: {

            /**
             * 모듈로드
             */
            load() {
                if (this.loadState !== 'unload') {
                    return;
                }

                this.loadState = 'loading';
                // ajax 옵션
                let cmp = this;
                let opts = {
                    type: 'get',
                    url: '/errors/' + this.errorId,
                    data: {
                        _token: this.csrfToken,
                    },
                    dataType: 'json',
                    success(response, textStatus, jqXHR) {
                        cmp.error = response.error;
                        cmp.loadState = 'loaded';
                    },
                    alert_error_msg(msg) {
                        alert(msg);
                        cmp.loadState = 'unload';
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },

            /**
             * 팝업열기
             * @return void
             */
            openView() {
                // 팝업기능 사용안함
                if (this.disabledView) {
                    return;
                }

                this.viewDisplay = true;

                // 데이터 로드
                if (this.loadState === 'unload') {
                    this.load();
                }
            },

            /**
             * 팝업닫기
             * @return void
             */
            closeView() {
                // 팝업기능 사용안함
                if (this.disabledView) {
                  return;
                }


                this.viewDisplay = false;
            },
        },
    }
</script>